<template>
    <div class="my-reserve-list" v-if="data">
      <div class="con-img"><img v-lazy="getLazyLoadObj(data.image)" alt=""/></div>
      <div class="con-text-wrap">
        <p class="con-tit">{{data.contenttitle}}</p>
        <p class="con-text01">방송일시 <span class="title-dot"></span> {{data.releasedatetime}}</p>
        <p class="con-text01">{{data.channeltitle}}</p>
      </div>
      <div class="reserve-check">
        <btn-live-alarm class="live-view-ch" isOn="y"
                        :targetDate="data.releasedatetime"
                        :contentsId="data.contentid"
                        :content-type="data.contenttype"
                        :game-id="data.gameid"
                        :content-title="data.contenttitle" />
      </div>
    </div>
</template>

<script>
import BtnLiveAlarm from '@/components/button/BtnLiveAlarm'
import { resizeThumbnail } from '@/common/utils/image'
export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnLiveAlarm
  },
  data () {
    return {
      placeholderImage: require('../../assets/images/common/img_default_thum_2.png')
    }
  },
  methods: {
    getLazyLoadObj (image) {
      return {
        src: resizeThumbnail(image, { width: 242, height: 136, isSquare: false }),
        error: this.placeholderImage,
        loading: this.placeholderImage
      }
    },
    url (url) {
      return location.protocol + '//' + url
    }
  }
}
</script>

<style lang="css">
label {
  cursor: pointer;
  margin: 0;
  padding: 0;
  vertical-align: middle
}
.reserve-check .check-time input[type="checkbox"] + label:before {
  margin-top:0;
}
.check-time input[type="checkbox"] + label:before {
  content:"";
  margin-top:8px;
  display:inline-block;
  width:24px;
  height:24px;
  background:url(../../assets/images/schedule/icon-alart-off.png) no-repeat center;
}
.check-time input[type="checkbox"]:checked + label:before {
  background:url(../../assets/images/mypooq/icon-alart-on.png) no-repeat center;
}
</style>
